<script setup>
import {ref} from "vue";

/*父传子数据*/
const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: '确定执行操作吗？'
  },
  title: {
    type: String,
    default: '温馨提示'
  },
  maxWidth: {
    type: Number,
    default: 400
  }
})

/*定义点击按钮传递事件*/
const emit = defineEmits(['confirm', 'cancel'])

// 确认执行操作
const handleConfirm = () => {
  emit('confirm')
}
// 取消执行操作
const handleCancel = () => {
  emit('cancel')
  console.log('对话框关闭')
}
</script>

<template>
  <v-dialog
    v-model="props.open"
    width="auto"
    :close-on-back="false"
    transition="dialog-bottom-transition"
    persistent
  >
    <v-card
        :max-width="maxWidth"
        :text="text"
        :title="title"
    >
      <template v-slot:actions>
        <v-btn
            class="ms-auto"
            text="确认"
            @click="handleConfirm"
        ></v-btn>
        <v-btn
            class="ms-auto"
            text="返回"
            @click="handleCancel"
        ></v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>